import { ReactNode } from 'react';
import ConfigProvider, { ThemeConfig } from 'antd/es/config-provider';
import theme from 'antd/es/theme';

const THEME: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
};

interface Props {
  children: ReactNode;
}

export default function AntdThemeProvider(props: Props) {
  return <ConfigProvider theme={THEME}>{props.children}</ConfigProvider>;
}
